
export function percentage({source, identify, match}) {
    const total = source.reduce((r, v) => r + identify(v), 0)
    const count = identify(source.find(match) || {}) || 0
    return Math.round(count / total * 100)
}

export function average({source, identify = (v) => v, accuracy = 1}) {
    return Math.round(source.reduce((r, v) => r + identify(v), 0) / source.length / accuracy) * accuracy
}

export function max({source, identify = (v) => v}) {
    return source.reduce((result, value) => {
    	const val = identify(value)
    	return val > result && val || result
    }, 0)
}


// WEBPACK FOOTER //
// ./lib/core/mathz.js